import React, { useEffect, useRef, useState } from 'react';

/**
 * Mounts children only when the placeholder nears the viewport.
 * Keeps layout stable via minHeight until content loads.
 */
export default function DeferredSection({ children, minHeight = 320, rootMargin = '480px 0px' }) {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el || visible) return undefined;

    if (typeof window === 'undefined' || !('IntersectionObserver' in window)) {
      setVisible(true);
      return undefined;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry?.isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { rootMargin, threshold: 0.01 },
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, [rootMargin, visible]);

  return (
    <div ref={ref} style={visible ? undefined : { minHeight }} aria-hidden={!visible}>
      {visible ? children : null}
    </div>
  );
}
